export const NO_ASSIGNEE_VALUE = 'no_assignee';
